import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./Flash.scss";
import { FlashFavoriteCheck, SetFlashFavorite } from "../axios";
import { useLocation } from "react-router-dom";

export const AddFavoriteIcon = ({ className }) => {
  return (
    <svg
      className={className}
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      aria-hidden="true"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      ></path>
    </svg>
  );
};

const Flash = ({ item, index, flashId, onClick }) => {
  const [fileUrl , setFileUrl] = useState("")
  
  const addToFavorite = (e, id, categoryID) => {
    e.preventDefault();

    if (localStorage.getItem("login")) {
      FlashFavoriteCheck(localStorage.getItem("phonenumber"), id).then(
        ({ data }) => {
          if (data === "0") {
            SetFlashFavorite(
              localStorage.getItem("phonenumber"),
              id,
              categoryID
            ).then((response) => {
              if (response.data === "1") {
                toast.success("به جعبه من اضافه شد");
              } else {
                toast.error("عملیات ادد با خطا مواجه شد.");
              }
            });
          } else {
            toast.error("قبلا به جعبه من اضافه شده است!");
          }
        }
      );
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  const flip = (e) => {
    e.preventDefault();
    // console.log(e.target.id);
    if (e.target.id !== null && e.target.id !== "") {
      var f = document.getElementById(e.target.id);
      f.classList.add("flipped");
    }
  };

  const undo = (e) => {
    e.preventDefault();
    // console.log(e.target.id);
    if (e.target.id !== null && e.target.id !== "") {
      var f = document.getElementById(e.target.id);
      f.classList.remove("flipped");
    }
  };

  // useEffect(() => {
  //     if (item) {
  //       // Delay for 2 seconds before creating the URL
  //       const timeoutId = setTimeout(() => {
  //         const fileUrl = `${mediaBaseUrl}${item?.filedemo}.jpg`;
  //         console.log("media", mediaBaseUrl);
          
  //         setFileUrl(fileUrl); // Assuming you have a state like `const [fileUrl, setFileUrl] = useState("");`
  //       }, 1000);
    
  //       // Cleanup timeout on component unmount or when `result` changes
  //       return () => clearTimeout(timeoutId);
  //     }
  //   }, [item]);

  const { pathname } = useLocation();
  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  // console.log("item is iddddddd " , item.id);
  // console.log("item is " , fileUrl);

  return (
    <article className="single_product flash-card">
      <div className="deck" onClick={onClick}>
        <div id={item.id} className="card ">
          <div className="front face flash-card">
            <img
              src={item.filedemo}
              style={{
                width: "250px",
                height: "350px",
                borderRadius: "10px",
                objectFit: "fill",
              }}
              alt="Flash_image"
            />
            <p className="flash-card-footer">
              {index}. {item.title}
            </p>
          </div>
        </div>
      </div>
      <div className="action_links">
        <ul>
          <li>
            <button
              // style={{ color: "white", marginRight: "15px" }}
              onClick={(e) => addToFavorite(e, item.id, item.subCategoryID)}
              title="افزودن به جعبه من "
              className="btn btn-primary btn-sm rounded-circle"
            >
              <AddFavoriteIcon />
            </button>
          </li>
        </ul>
      </div>
    </article>
  );
};

export default Flash;
